import { render, staticRenderFns } from "./MenuConfigWindow.vue?vue&type=template&id=3155dfd7&scoped=true&"
import script from "./MenuConfigWindow.vue?vue&type=script&lang=js&"
export * from "./MenuConfigWindow.vue?vue&type=script&lang=js&"
import style0 from "./MenuConfigWindow.vue?vue&type=style&index=0&id=3155dfd7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3155dfd7",
  null
  
)

export default component.exports